const TipoCadastroMultiprofissionalOptions = [
  { id: 4, text: "Enfermeiro (a)", value:"Enfermeiro" },
  { id: 5, text: "Fisioterapeuta", value:"Fisioterapeuta" },
  { id: 6, text: "Fonoaudiólogo (a)", value:"Fonoaudiologo" },
  { id: 7, text: "Instrumentador (a)", value:"Instrumentador" },
  { id: 8, text: "Nutricionista", value:"Nutricionista" },
  { id: 9, text: "Psicólogo (a)", value:"Psicologo" },
  { id: 10, text: "Terapeuta Ocupacional", value:"TerapeutaOcupacional" },
];

export { TipoCadastroMultiprofissionalOptions};
